import { render, staticRenderFns } from "./PnetSubmitQuoteUpdate.vue?vue&type=template&id=16af7818&scoped=true"
import script from "./PnetSubmitQuoteUpdate.vue?vue&type=script&lang=js"
export * from "./PnetSubmitQuoteUpdate.vue?vue&type=script&lang=js"
import style0 from "./PnetSubmitQuoteUpdate.vue?vue&type=style&index=0&id=16af7818&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af7818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16af7818')) {
      api.createRecord('16af7818', component.options)
    } else {
      api.reload('16af7818', component.options)
    }
    module.hot.accept("./PnetSubmitQuoteUpdate.vue?vue&type=template&id=16af7818&scoped=true", function () {
      api.rerender('16af7818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/PnetSubmitQuoteUpdate.vue"
export default component.exports